import React from 'react'
import { CardStyled } from '../../styles';
import { riskColors, riskLabels } from '../../ConditionCard';
import { I18n } from '@aws-amplify/core';

type Props = {
	result: number;
}

export const ConditionalCard = ({ result }: Props) => {
	return (
		<CardStyled $backgroundColor={riskColors[result]} risk={result}>
			{I18n.get(riskLabels[result])}
		</CardStyled>
	)
}

